import type { FaireProductEntity } from "../../entity_types/product";

export const p_9c8z6emz5c: FaireProductEntity = {
  token: "p_9c8z6emz5c",
  type: "product",
  name: "Tractor Shirt for Toddler Kids, A little Dirt Never Hurt Tee",
  brandToken: "b_bftwxtye3z",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e6e78649fe8f7b32aa037bce8522cf9585516c36e68e16b7f12d65ac4ccd9e84.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed6338cf1d41c296589467b260d8efab3723075d74aedce5c77c2f411aec414f.jpeg",
    "https://cdn.faire.com/fastly/c13281c2b5c27a894449dea4b619245870eb0e92fb05acd302c69a5baef331e2.jpeg",
    "https://cdn.faire.com/fastly/23fd1410867894728f1a6bd52330edfa6afabdcf0bec41c833f0bb4a3779a42c.jpeg",
    "https://cdn.faire.com/fastly/3150c5d1d9f603c913bcc84ff747335abc107e084dae78aa25b49d5fbf30d18d.jpeg",
  ],
  priceDollars: 16.98,
  description:
    'tractor tee on heather green shirt with black ink, words read "a little dirt never hurt" arching over a tractor. \n\nTees are 50% Cotton, 25% Polyester and 25% Rayon\n\nImage is silk screened onto tee- which means image will never crack or fade!\nAll shirts are "tag less" and come with Ginger + Babe and the size printed on the inside of the shirt. \n',
  tags: [],
  msrpDollars: 33.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:02.389Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
